// extracted by mini-css-extract-plugin
module.exports = {"share":"LearnerResultShare_share__2sUWT","social":"LearnerResultShare_social__b0CSr","copy":"LearnerResultShare_copy__1aifv","check":"LearnerResultShare_check__2QKhe"};